var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fade-animation {\r\n        animation: fade 3s ease-in-out infinite;\r\n    }\r\n\r\n    @keyframes fade {\r\n        0%, 40%, 100% {\r\n            opacity: 0;\r\n        }\r\n        60%, 80% {\r\n            opacity: 1;\r\n        }\r\n    }\r\n\t\r\n    .fade-animation2 {\r\n        animation: fade2 3s ease-in-out infinite;\r\n    }\r\n\r\n    @keyframes fade2 {\r\n        0%, 20%, 60%, 100% {\r\n            opacity: 0;\r\n        }\r\n        40% {\r\n            opacity: .70;\r\n        }\r\n    }\r\n\t\r\n    .fade-animation3 {\r\n        animation: fade3 3s ease-in-out infinite;\r\n    }\r\n\r\n    @keyframes fade3 {\r\n        0%, 10%, 50%, 100% {\r\n            opacity: 0;\r\n        }\r\n        30% {\r\n            opacity: .5;\r\n        }\r\n    }\r\n    \r\n    .FarfallaSmallest {\r\n\t\topacity: 0;\r\n    }\r\n    .FarfallaSmall {\r\n\t\topacity: 0;\r\n    }\r\n    .FarfallaPrincipal {\r\n\t\topacity: 0;\r\n    }\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "FarfallaSmallest fade-animation3",
    id: "Group_4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_46_00000181767089322282909930000016997111754167670718_",
    gradientUnits: "userSpaceOnUse",
    x1: -888.4795,
    y1: 65.9351,
    x2: -888.9197,
    y2: 65.406,
    gradientTransform: "matrix(15.766 0 0 14.2441 14074.3145 -900.8706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#86BE49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46_00000072976207919367321830000015065022283340031890_",
    style: {
      fill: "url(#Path_46_00000181767089322282909930000016997111754167670718_)"
    },
    d: " M66.4,38.4C66.4,38.4,66.4,38.4,66.4,38.4c-3.4-1-6.2-3.4-7.7-6.7c0.4-0.1,0.9-0.1,1.4-0.1C63.6,31.5,66.4,34.6,66.4,38.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_47_00000175281221305750897140000004273174777566491782_",
    gradientUnits: "userSpaceOnUse",
    x1: -874.7273,
    y1: 29.1377,
    x2: -874.7273,
    y2: 28.6519,
    gradientTransform: "matrix(12.9547 0 0 32.408 11392.2959 -913.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6622"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47_00000086667199842268382790000005410448918877382062_",
    style: {
      fill: "url(#Path_47_00000175281221305750897140000004273174777566491782_)"
    },
    d: " M63.6,21.9c0,3.7-1.9,7.2-5.2,9.1c-0.8-1.8-1.2-3.7-1.2-5.7c0-3.7,1.5-7.3,4.1-10C62.8,17.2,63.6,19.5,63.6,21.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "FarfallaSmall fade-animation2",
    id: "Group_3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: -889.0554,
    y1: 66.6525,
    x2: -889.7283,
    y2: 65.8437,
    gradientTransform: "matrix(15.766 0 0 14.2441 14074.3145 -900.8706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#86BE49"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    d: "M57.3,48.6c0,0.1,0,0.1,0,0.1c-5.1-1.7-9.4-5.4-11.7-10.3c0.7-0.1,1.4-0.2,2.1-0.2C53,38.1,57.3,42.8,57.3,48.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: -875.6763,
    y1: 29.334,
    x2: -875.6763,
    y2: 28.5914,
    gradientTransform: "matrix(12.9547 0 0 32.408 11392.2959 -913.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6622"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    d: "M53,23.4c0.1,5.7-2.9,11.1-7.9,14c-1.2-2.7-1.8-5.7-1.8-8.8c0-5.7,2.2-11.2,6.2-15.3C51.8,16.2,53,19.8,53,23.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "FarfallaPrincipal fade-animation",
    id: "Group_1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: -889.8452,
    y1: 67.4311,
    x2: -890.7512,
    y2: 66.3421,
    gradientTransform: "matrix(15.766 0 0 14.2441 14074.3145 -900.8706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#86BE49"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    d: "M44.8,59.7c0,0.1,0,0.1,0,0.2C37.9,57.6,32.1,52.6,29,46c0.9-0.2,1.9-0.3,2.8-0.3C39,45.6,44.8,51.9,44.8,59.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: -876.886,
    y1: 29.5569,
    x2: -876.886,
    y2: 28.5571,
    gradientTransform: "matrix(12.9547 0 0 32.408 11392.2959 -913.2798)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F59F1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED6622"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    d: "M39,25.8c0.1,7.7-3.9,14.9-10.6,18.8c-1.6-3.7-2.4-7.7-2.4-11.8c0-7.7,3-15.1,8.4-20.6C37.4,16.1,39,20.9,39,25.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon-loading.bfd399724299782b905ea3ed9fd4e2b5.svg";
export { ForwardRef as ReactComponent };